(function () {
    'use strict';

    angular.module('itxApp.common').service('wwTranslationSvc', wwTranslationSvc);

    wwTranslationSvc.$inject = ['ItxTranslateSvc'];

    function wwTranslationSvc(ItxTranslateSvc) {
        var _this = this;

        _this.translationsTexts = {
            MEN: {
                '-1': 'MEN', //inglés
                '-2': 'HOMMES', // francés
                '-3': 'HERREN', // alemán
                '-4': 'UOMO', // italiano
                '-5': 'HOMBRE', // cast
                '-6': 'HOMEM', // portugués
                '-7': '男装', // chino
                '-8': '男士', // chino tradicional
                '-9': '남성 컬렉션', // coreano
                '-11': 'GIZONA', // Euskera
                '-12': 'HOME', // Gallego
                '-13': 'HOME', // Catalán
                '-14': 'ΆΝΔΡΑΣ', // Griego
                '-20': 'МУЖЧИНЫ', // ruso
                '-21': 'BĂRBAŢI', // rumano
                '-22': 'MĘŻCZYZNA', // polaco
                '-26': 'HERREN', // flamenco
                '-27': 'MUŽI', // checo
                '-28': 'PÁNSKE', // eslovaco
                '-30': 'МЪЖКА МОДА', // búlgaro
                '-33': 'VYRAMS', // Lituano LT
                '-34': 'MEHED', // Estonio ET
                '-35': 'VĪRIEŠIEM', // Letón LV
                '-36': 'MOŠKI', // Esloveno
                '-37': 'ผู้ชาย', // Tailandés
                '-38': 'MUŠKARAC', // croata
                '-39': 'HERRE', // danés
                '-40': 'HERRER', // noruego
                '-43': 'ERKEK', // Turco
                '-44': 'رجال', // Árabe AR
                '-47': 'Чоловіки', // Ukranian
                '-49': 'PRIA', // Indonesio
                '-50': 'HOMBRE', // mexicano
                '-52': 'גברים', // Hebreo
                '-53': 'MUŠKARCI', // Serbio
                '-54': 'NAM', // Vietnamita
                '-55': 'MEN', // Albanés
                '-56': 'МАЖИ', // Macedonio
                '100': 'HERREN' //Holandés
            },
            WOMEN: {
                '-1': 'WOMEN', //inglés
                '-2': 'FEMMES', // francés
                '-3': 'DAMEN', // alemán
                '-4': 'DONNA', // italiano
                '-5': 'MUJER', // cast
                '-6': 'MULHER', // portugués
                '-7': '女装', // chino
                '-8': '女士', // chino tradicional
                '-9': '여성 컬렉션', // coreano
                '-11': 'EMAKUMEA', // Euskera
                '-12': 'MULLER', // Gallego
                '-13': 'DONA', // Catalán
                '-14': 'ΓΥΝΑΊΚΑ', // Griego
                '-20': 'ЖЕНЩИНЫ', // ruso
                '-21': 'FEMEI', // rumano
                '-22': 'KOBIETA', // polaco
                '-26': 'DAMEN', // flamenco
                '-27': 'ŽENY', // checo
                '-28': 'DÁMSKE', // eslovaco
                '-30': 'ДАМСКА МОДА', // búlgaro
                '-33': 'MOTERIMS', // Lituano LT
                '-34': 'NAISED', // Estonio ET
                '-35': 'SIEVIETĒM', // Letón LV
                '-36': 'ŽENSKE', // Esloveno
                '-37': 'ผู้หญิง', // Tailandés
                '-38': 'ŽENA', // croata
                '-39': 'DAME', // danés
                '-40': 'DAMER', // noruego
                '-43': 'KADIN', // Turco
                '-44': 'نساء', // Árabe AR
                '-47': 'Жінки', // Ukranian
                '-49': 'WANITA', // Indonesio
                '-50': 'MUJER', // mexicano
                '-52': 'נשים', // Hebreo
                '-53': 'ŽENE', // Serbio
                '-54': 'NỮ', // Vietnamita
                '-55': 'WOMEN', // Albanés
                '-56': 'ЖЕНИ', // Macedonio
                '100': 'DAMEN' //Holandés
            },
            BG: {
                '-1': 'BOYS & GIRLS', //inglés
                '-2': 'ENFANTS', // francés
                '-3': 'KINDER', // alemán
                '-4': 'BAMBINI', // italiano
                '-5': 'NIÑOS', // cast
                '-6': 'CRIANÇAS', // portugués
                '-7': '男女童装', // chino
                '-8': '男童和女童', // chino tradicional
                '-9': '아동 의류', // coreano
                '-11': 'HAURRAK', // Euskera
                '-12': 'NENOS', // Gallego
                '-13': 'NENS', // Catalán
                '-14': 'ΠΑΙΔΙΚΑ', // Griego
                '-20': 'ДЕТИ', // ruso
                '-21': 'COPII', // rumano
                '-22': 'DZIECI', // polaco
                '-26': 'KINDER', // flamenco
                '-27': 'DĚTI', // checo
                '-28': 'DETSKÉ', // eslovaco
                '-30': 'ДЕТСКА МОДА', // búlgaro
                '-33': 'VAIKAMS', // Lituano LT
                '-34': 'LAPSED', // Estonio ET
                '-35': 'BĒRNIEM', // Letón LV
                '-36': 'FANTJE IN DEKLETA', // Esloveno
                '-37': 'เด็กหญิงและเด็กชาย', // Tailandés
                '-38': 'DJECA', // croata
                '-39': 'BØRN', // danés
                '-40': 'BARN', // noruego
                '-43': 'ÇOCUK', // Turco
                '-44': 'الصبيان والبنات', // Árabe AR
                '-47': 'Хлопчики та дівчатка', // Ukranian
                '-49': 'ANAK LAKI-LAKI & PEREMPUAN', // Indonesio
                '-50': 'NIÑOS', // mexicano
                '-52': 'בנים ובנות', // Hebreo
                '-53': 'DEČACI I DEVOJČICE', // Serbio
                '-54': 'BÉ TRAI & BÉ GÁI', // Vietnamita
                '-55': 'BOYS & GIRLS', // Albanés
                '-56': 'МОМЧИЊА И ДЕВОЈЧИЊА', // Macedonio
                '100': 'KINDER' //Holandés
            },
            CURRENT_LANGUAGE: {
                '-1': 'Current language', //inglés,
                '-2': 'Langue actuelle', // francés
                '-3': 'Aktuelle Sprache', // alemán
                '-4': 'Lingua attuale', // italiano
                '-5': 'Idioma actual', // cast
                '-6': 'Idioma atual', // portugués
                '-7': '当前语言', // chino
                '-8': '目前語言', // chino tradicional
                '-9': '현재 언어', // coreano
                '-11': 'Egungo hizkuntza', // Euskera
                '-12': 'Lingua actual', // Gallego
                '-13': 'Idioma actual', // Catalán
                '-14': 'Τρέχουσα γλώσσα', // Griego
                '-20': 'Текущий язык', // ruso
                '-21': 'Limba actuală', // rumano
                '-22': 'Aktualny język', // polaco
                '-26': 'Huidige taal', // flamenco
                '-27': 'Současný jazyk', // checo
                '-28': 'Aktuálny jazyk', // eslovaco
                '-30': 'Настоящ език', // búlgaro
                '-33': 'Dabartinė kalba', // Lituano LT
                '-34': 'Praegune keel', // Estonio ET
                '-35': 'Pašreizējā valoda', // Letón LV
                '-36': 'Trenutni Jezik', // Esloveno
                '-37': 'ภาษาที่ใช้ในตอนนี้', // Tailandés
                '-38': 'Sadašnji jezik', // croata
                '-39': 'Nuværende sprog', // danés
                '-40': 'Nåværende språk', // noruego
                '-43': 'Geçerli dil', // Turco
                '-44': 'اللغة الحالية', // Árabe AR
                '-47': 'Поточна мова', // Ukranian
                '-49': 'Bahasa saat ini', // Indonesio
                '-50': 'Idioma actual', // mexicano
                '-52': 'שפה נוכחית', // Hebreo
                '-53': 'Trenutni jezik', // Serbio
                '-54': 'Ngôn ngữ hiện tại', // Vietnamita
                '-55': 'Current language', // Albanés
                '-56': 'Тековен јазик', // Macedonio
                '100': 'Huidige taal' //Holandés
            },
            CHOOSE_CONTENT: {
                '-1': 'Choose content', //inglés
                '-2': 'Sélectionnez une section', // francés
                '-3': 'Wählen Sie eine Abteilung', // alemán
                '-4': 'Seleziona una sezione', // italiano
                '-5': 'Selecciona una sección', // cast
                '-6': 'Selecione uma secção', // portugués
                '-7': '选择内容', // chino
                '-8': '選擇內容', // chino tradicional
                '-9': '섹션을 선택하세요', // coreano
                '-11': 'Aukeratu edukia', // Euskera
                '-12': 'Escolla contido', // Gallego
                '-13': 'Trieu contingut', // Catalán
                '-14': 'Επιλέξτε ένα τμήμα', // Griego
                '-20': 'Выберите раздел', // ruso
                '-21': 'Selectați o secțiune', // rumano
                '-22': 'Wybierz dział', // polaco
                '-26': 'Kies inhoud', // flamenco
                '-27': 'Vyberte oddělení', // checo
                '-28': 'Vyberte obsah', // eslovaco
                '-30': 'Изберете секция', // búlgaro
                '-33': 'Pasirinkite skyrių', // Lituano LT
                '-34': 'Valige jaotis', // Estonio ET
                '-35': 'Izvēlieties sadaļu', // Letón LV
                '-36': 'Izberi Vsebino', // Esloveno
                '-37': 'เลือกเนื้อหา', // Tailandés
                '-38': 'Odaberite odjeljak', // croata
                '-39': 'Vælg en sektion', // danés
                '-40': 'Velg del', // noruego
                '-43': 'Bir bölüm seçin', // Turco
                '-44': 'حدد القسم', // Árabe AR
                '-47': 'Виберіть розділ', // Ukranian
                '-49': 'Pilih konten', // Indonesio
                '-50': 'Selecciona una sección', // mexicano
                '-52': 'בחרו תוכן', // Hebreo
                '-53': 'Izaberite sadržaj', // Serbio
                '-54': 'Chọn nội dung', // Vietnamita
                '-55': 'Choose content', // Albanés
                '-56': 'Избери содржина', // Macedonio
                '100': 'Selecteer een deel' //Holandés
            },
            CURRENT_MARKET: {
                '-1': 'Current market', //inglés
                '-2': 'Marché actuel', // francés
                '-3': 'Aktueller Markt', // alemán
                '-4': 'Mercato attuale', // italiano
                '-5': 'Mercado actual', // cast
                '-6': 'Mercado atual', // portugués
                '-7': '当前市场', // chino
                '-8': '目前市場', // chino tradicional
                '-9': '현재 시장', // coreano
                '-11': 'Egungo merkatua', // Euskera
                '-12': 'Mercado actual', // Gallego
                '-13': 'Mercat actual', // Catalán
                '-14': 'Τρέχουσα αγορά', // Griego
                '-20': 'Текущая рынок', // ruso
                '-21': 'Piața actuală', // rumano
                '-22': 'Obecny rynek', // polaco
                '-26': 'Huidige markt', // flamenco
                '-27': 'Současný trh', // checo
                '-28': 'Súčasný trh', // eslovaco
                '-30': 'Настоящ пазар', // búlgaro
                '-33': 'Dabartinė rinka', // Lituano LT
                '-34': 'Trenutno tržišče', // Estonio ET
                '-35': 'Pašreizējais tirgus', // Letón LV
                '-36': 'Trenutni Trg', // Esloveno
                '-37': 'ประเทศปัจจุบัน', // Tailandés
                '-38': 'Trenutačno tržište', // croata
                '-39': 'Nuværende marked', // danés
                '-40': 'Aktuelt marked', // noruego
                '-43': 'Güncel yerel pazar', // Turco
                '-44': 'الانتقال إلى السوق الحالي', // Árabe AR
                '-47': 'Перейдіть на ваш поточний ринок:', // Ukranian
                '-49': 'Pasar saat ini', // Indonesio
                '-50': 'Mercado actual', // mexicano
                '-52': 'מדינה נוכחית', // Hebreo
                '-53': 'Trenutno tržište', // Serbio
                '-54': 'Thị trường hiện tại', // Vietnamita
                '-55': 'Current market', // Albanés
                '-56': 'Тековен пазар', // Macedonio
                '100': 'Huidige markt' //Holandés
            },
            SELECT_LOCATION: {
                '-1': 'Select location:', //inglés
                '-2': 'Sélectionner un autre marché:', // francés
                '-3': 'Anderen Markt wählen:', // alemán
                '-4': 'Selezionare un altro Mercato:', // italiano
                '-5': 'Seleccionar otro mercado:', // cast
                '-6': 'Selecionar outro mercado:', // portugués
                '-7': '选择地点:', // chino
                '-8': '選擇地點', // chino tradicional
                '-9': '다른 시장 선택:', // coreano
                '-11': 'Aukeratu kokapena:', // Euskera
                '-12': 'Selecciona a situación:', // Gallego
                '-13': 'Selecciona la ubicació:', // Catalán
                '-14': 'Επιλογή άλλης αγοράς:', // Griego
                '-20': 'Выбрать другой рынок:', // ruso
                '-21': 'Selectați altă piață:', // rumano
                '-22': 'Wybierz inny rynek:', // polaco
                '-26': 'Selecteer een locatie:', // flamenco
                '-27': 'Vyberte jiný trh:', // checo
                '-28': 'Vyberte miesto:', // eslovaco
                '-30': 'Изберете друг пазар:', // búlgaro
                '-33': 'Pasirinkti kitą rinką:', // Lituano LT
                '-34': 'Vali teine turg:', // Estonio ET
                '-35': 'Izvēlēties citu tirgu:', // Letón LV
                '-36': 'Izberi Lokacijo', // Esloveno
                '-37': 'เลือกที่ตั้ง', // Tailandés
                '-38': 'Odaberi drugo tržište:', // croata
                '-39': 'Vælg et andet marked:', // danés
                '-40': 'Velg et annet marked:', // noruego
                '-43': 'Başka yerel pazar seçin:', // Turco
                '-44': 'حدد سوقًا آخر:', // Árabe AR
                '-49': 'Pilih lokasi', // Indonesio
                '-50': 'Seleccionar otro mercado', // mexicano
                '-52': 'בחרו מיקום', // Hebreo
                '-53': 'Izaberite lokaciju', // Serbio
                '-54': 'Chọn địa điểm', // Vietnamita
                '-55': 'Select location:', // Albanés
                '-56': 'Избери локација', // Macedonio
                '100': 'Andere markt selecteren:' //Holandés
            },
            SELECT_SHIPPING_COUNTRY: {
                '-1': 'Search for your market', //inglés
                '-2': 'Cherchez votre marché', // francés
                '-3': 'Suchen Sie Ihren Markt', // alemán
                '-4': 'Cerca il tuo mercato', // italiano
                '-5': 'Busca tu mercado', // cast
                '-6': 'Procure o seu mercado', // portugués
                '-7': '搜索您的市场', // chino
                '-8': '搜尋您的市場', // chino tradicional
                '-9': '시장을 검색하세요', // coreano
                '-11': 'Bilatu zure merkatua', // Euskera
                '-12': 'Busca o teu mercado', // Gallego
                '-13': 'Busca el teu mercat', // Catalán
                '-14': 'Αναζητήστε την αγορά σας', // Griego
                '-20': 'Найдите свой рынок', // ruso
                '-21': 'Căutați piața dvs.', // rumano
                '-22': 'Szukaj swojego rynku', // polaco
                '-27': 'Vyhledejte svůj trh', // checo
                '-28': 'Nájdite si svoj trh', // eslovaco
                '-30': 'Потърсете своя пазар', // búlgaro
                '-33': 'Ieškokite savo rinkos', // Lituano LT
                '-34': 'Otsige oma turgu', // Estonio ET
                '-35': 'Meklējiet savu tirgu', // Letón LV
                '-36': 'Izberi Državo Pošiljanja', // Esloveno
                '-37': 'ค้นหาประเทศ', // Tailandés
                '-38': 'Pronađite svoje tržište', // croata
                '-39': 'Søg efter dit marked', // danés
                '-40': 'Søk etter markedet ditt', // noruego
                '-43': 'Yerel pazarınızı arayın', // Turco
                '-44': 'بحث عن سوق', // Árabe AR
                '-47': 'Пошук свого ринку', // Ukranian
                '-49': 'Cari pasar Anda', // Indonesio
                '-50': 'Busca tu mercado', // mexicano
                '-52': 'חפשו את השוק שלכם', // Hebreo
                '-53': 'Potražite svoje tržište', // Serbio
                '-54': 'Tìm thị trường của bạn', // Vietnamita
                '-55': 'Search for your market', // Albanés
                '-56': 'Побарајте пазар', // Macedonio
                '100': 'Zoek uw markt' //Holandés
            },
            NO_RESULTS: {
                '-1': 'There are no results to display.', //inglés
                '-2': "Il n'y a aucun résultat à afficher.", // francés
                '-3': 'Keine Resultate zum Anzeigen.', // alemán
                '-4': 'Nessun risultato rilevato.', // italiano
                '-5': 'No hay resultados a mostrar.', // cast
                '-6': 'Não há resultados a mostrar.', // portugués
                '-7': '无可显示的结果。', // chino
                '-8': '無可顯示的結果。', // chino tradicional
                '-9': '찾으시는 결과가 없습니다.', // coreano
                '-11': 'Ez dago emaitzarik.', // Euskera
                '-12': 'Non hai resultados para mostrar.', // Gallego
                '-13': 'No hi ha resultats a mostrar.', // Catalán
                '-14': 'Δεν βρέθηκαν αποτελέσματα.', // Griego
                '-20': 'Нет результатов для отображения.', // ruso
                '-21': 'Nu există rezultate de afişat.', // rumano
                '-22': 'Brak wyników do pokazania.', // polaco
                '-26': 'Er zijn geen resultaten om weer te geven.', //flamenco
                '-27': 'Nebyly nalezeny žádné výsledky.', // checo
                '-28': 'Ni rezultatov za prikaz.', // eslovaco
                '-30': 'Няма намерени резултати.', // búlgaro
                '-33': 'Nėra galimų rezultatų.', // Lituano LT
                '-34': 'Kuvamiseks pole tulemusi.', // Estonio ET
                '-35': 'Nav rezultātu, ko parādīt.', // Letón LV
                '-36': 'Ni rezultatov za prikaz', // Esloveno
                '-37': 'ไม่มีผลลัพธ์ที่ต้องแสดง', // Tailandés
                '-38': 'Nema rezultata za prikaz.', // croata
                '-39': 'Søgningen gav ingen resultater.', // danés
                '-40': 'Ingen resultater å vise.', // noruego
                '-43': 'Yerel pazarınızı arayın', // Turco
                '-44': 'لا توجد نتائج لعرضها.', // Árabe AR
                '-47': 'Немає результатів для відображення.', // Ukranian
                '-49': 'Tidak ada hasil.', // Indonesio
                '-50': 'No hay resultados a mostrar.', // mexicano
                '-52': 'אין תוצאות להציג.', // Hebreo
                '-53': 'Nema rezultata za prikaz.', // Serbio
                '-54': 'Không có kết quả hiển thị.', // Vietnamita
                '-55': 'There are no results to display.', // Albanés
                '-56': 'Нема резултати за прикажување.', // Macedonio
                '100': 'Görüntülenecek sonuç yok.' //Holandés
            },
            AFRICA: {
                '-1': 'Africa', //inglés
                '-2': 'Afrique', // francés
                '-3': 'Afrika', // alemán
                '-4': 'Africa', // italiano
                '-5': 'África', // cast
                '-6': 'África', // portugués
                '-7': '非洲', // chino
                '-8': '非洲', // chino tradicional
                '-9': '아프리카', // coreano
                '-11': 'Afrika', // Euskera
                '-12': 'África', // Gallego
                '-13': 'Àfrica', // Catalán
                '-14': 'Αφρική', // Griego
                '-20': 'Африка', // ruso
                '-21': 'Africa', // rumano
                '-22': 'Afryka', // polaco
                '-26': 'Afrika', //flamenco
                '-27': 'Afrika', // checo
                '-28': 'Afrika', // eslovaco
                '-30': 'Африка', // búlgaro
                '-33': 'Āfrika', // Lituano LT
                '-34': 'Aafrika', // Estonio ET
                '-35': 'Āfrika', // Letón LV
                '-36': 'Afrika', // Esloveno
                '-37': 'แอฟริกา', // Tailandés
                '-38': 'Afrika', // croata
                '-39': 'Afrika', // danés
                '-40': 'Afrika', // noruego
                '-43': 'Afrika', // Turco
                '-44': 'إفريقيا', // Árabe AR
                '-47': 'Африка.', // Ukranian
                '-49': 'Afrika', // Indonesio
                '-50': 'África', // mexicano
                '-52': 'אפריקה', // Hebreo
                '-53': 'Afrika', // Serbio
                '-54': 'Châu Phi', // Vietnamita
                '-55': 'Africa', // Albanés
                '-56': 'Африка', // Macedonio
                '100': 'Afrika' //Holandés
            },
            AMERICA: {
                '-1': 'America', //inglés
                '-2': 'Amérique', // francés
                '-3': 'Amerika', // alemán
                '-4': 'America', // italiano
                '-5': 'América', // cast
                '-6': 'América', // portugués
                '-7': '美洲', // chino
                '-8': '美洲', // chino tradicional
                '-9': '아메리카', // coreano
                '-11': 'Amerika', // Euskera
                '-12': 'América', // Gallego
                '-13': 'Amèrica', // Catalán
                '-14': 'Αμερική', // Griego
                '-20': 'Америка', // ruso
                '-21': 'America', // rumano
                '-22': 'Ameryka', // polaco
                '-26': 'Amerika', // flamenco
                '-27': 'Amerika', // checo
                '-28': 'Amerika', // eslovaco
                '-30': 'Америка', // búlgaro
                '-33': 'Amerika', // Lituano LT
                '-34': 'Ameerika', // Estonio ET
                '-35': 'Amerika', // Letón LV
                '-36': 'Amerika', // Esloveno
                '-37': 'อเมริกา', // Tailandés
                '-38': 'Amerika', // croata
                '-39': 'Amerika', // danés
                '-40': 'Amerika', // noruego
                '-43': 'Amerika', // Turco
                '-44': 'أمريكا', // Árabe AR
                '-47': 'Америка.', // Ukranian
                '-49': 'Amerika', // Indonesio
                '-50': 'América', // mexicano
                '-52': 'אמריקה', // Hebreo
                '-53': 'Amerika', // Serbio
                '-54': 'Châu Mỹ', // Vietnamita
                '-55': 'America', // Albanés
                '-56': 'Америка', // Macedonio
                '100': 'Amerika' //Holandés
            },
            ASIA: {
                '-1': 'Asia', //inglés
                '-2': 'Asie', // francés
                '-3': 'Asien', // alemán
                '-4': 'Asia', // italiano
                '-5': 'Asia', // cast
                '-6': 'Ásia', // portugués
                '-7': '亚洲', // chino
                '-8': '亞洲', // chino tradicional
                '-9': '아시아', // coreano
                '-11': 'Asia', // Euskera
                '-12': 'Asia', // Gallego
                '-13': 'Àsia', // Catalán
                '-14': 'Ασία', // Griego
                '-20': 'Азия', // ruso
                '-21': 'Asia', // rumano
                '-22': 'Azja', // polaco
                '-26': 'Azië', // flamenco
                '-27': 'Asie', // checo
                '-28': 'Asia', // eslovaco
                '-30': 'Азия', // búlgaro
                '-33': 'Azija', // Lituano LT
                '-34': 'Azija', // Estonio ET
                '-35': 'Āzija', // Letón LV
                '-36': 'Azija', // Esloveno
                '-37': 'เอเชีย', // Tailandés
                '-38': 'Azija', // croata
                '-39': 'Asien', // danés
                '-40': 'Asia', // noruego
                '-43': 'Asya', // Turco
                '-44': 'أسيا', // Árabe AR
                '-47': 'Азія.', // Ukranian
                '-49': 'Asia', // Indonesio
                '-50': 'Asia', // mexicano
                '-52': 'אסיה', // Hebreo
                '-53': 'Azija', // Serbio
                '-54': 'Châu Á', // Vietnamita
                '-55': 'Asia', // Albanés
                '-56': 'Азија', // Macedonio
                '100': 'Azië' //Holandés
            },
            EUROPE: {
                '-1': 'Europe', //inglés
                '-2': 'Europe', // francés
                '-3': 'Europa', // alemán
                '-4': 'Europa', // italiano
                '-5': 'Europa', // cast
                '-6': 'Europa', // portugués
                '-7': '欧洲', // chino
                '-8': '歐洲', // chino tradicional
                '-9': '유럽', // coreano
                '-11': 'Europa', // Euskera
                '-12': 'Europa', // Gallego
                '-13': 'Europa', // Catalán
                '-14': 'Ευρώπη', // Griego
                '-20': 'Европа', // ruso
                '-21': 'Europa', // rumano
                '-22': 'Europa', // polaco
                '-26': 'Europa', // flamenco
                '-27': 'Evropa', // checo
                '-28': 'Europe', // eslovaco
                '-30': 'Europa', // búlgaro
                '-33': 'Europe', // Lituano LT
                '-34': 'Euroopa', // Estonio ET
                '-35': 'Europe', // Letón LV
                '-36': 'Evropa', // Esloveno
                '-37': 'ยุโรป', // Tailandés
                '-38': 'Europa', // croata
                '-39': 'Europe', // danés
                '-40': 'Europa', // noruego
                '-43': 'Avrupa', // Turco
                '-44': 'أوروبا', // Árabe AR
                '-47': 'Європа', // Ukranian
                '-49': 'Eropa', // Indonesio
                '-50': 'Europa', // mexicano
                '-52': 'אירופה', // Hebreo
                '-53': 'Evropa', // Serbio
                '-54': 'Châu Âu', // Vietnamita
                '-55': 'Europe', // Albanés
                '-56': 'Европа', // Macedonio
                '100': 'Europa' //Holandés
            },
            OCEANIA: {
                '-1': 'Oceania', //inglés
                '-2': 'Océanie', // francés
                '-3': 'Ozeanien', // alemán
                '-4': 'Oceania', // italiano
                '-5': 'Oceanía', // cast
                '-6': 'Oceânia', // portugués
                '-7': '大洋洲', // chino
                '-8': '大洋洲', // chino tradicional
                '-9': '오세아니아', // coreano
                '-11': 'Oceania', // Euskera
                '-12': 'Oceanía', // Gallego
                '-13': 'Oceania', // Catalán
                '-14': 'Ωκεανία', // Griego
                '-20': 'Океания', // ruso
                '-21': 'Oceania', // rumano
                '-22': 'Oceania', // polaco
                '-26': 'Oceanië', // flamenco
                '-27': 'Oceánie', // checo
                '-28': 'Oceánia', // eslovaco
                '-30': 'Океания', // búlgaro
                '-33': 'Okeanija', // Lituano LT
                '-34': 'Okeaania', // Estonio ET
                '-35': 'Okeānija', // Letón LV
                '-36': 'Oceanija', // Esloveno
                '-37': 'โอเชียเนีย', // Tailandés
                '-38': 'Oceanija', // croata
                '-39': 'Oceanien', // danés
                '-40': 'Oseania', // noruego
                '-43': 'Okyanusya', // Turco
                '-44': 'أوقيانوسيا', // Árabe AR
                '-47': 'Океанія', // Ukranian
                '-49': 'Oseania', // Indonesio
                '-50': 'Oceanía', // mexicano
                '-52': 'אוקיאניה', // Hebreo
                '-53': 'Okeanija', // Serbio
                '-54': 'Châu Đại Dương', // Vietnamita
                '-55': 'Oceania', // Albanés
                '-56': 'Океанија', // Macedonio
                '100': 'Ozeanien' //Holandés
            },
            MIDDLE_EAST: {
                '-1': 'Middle East', //inglés
                '-2': 'Moyen-Orient', // francés
                '-3': 'Mittlerer Osten', // alemán
                '-4': 'Medio Oriente', // italiano
                '-5': 'Oriente Medio', // cast
                '-6': 'Médio Oriente', // portugués
                '-7': '中东', // chino
                '-8': '中東', // chino tradicional
                '-9': '중동', // coreano
                '-11': 'Ekialde Hurbila', // Euskera
                '-12': 'Oriente Medio', // Gallego
                '-13': 'Orient Mitjà', // Catalán
                '-14': 'μέση Ανατολή', // Griego
                '-20': 'Средняя Азия', // ruso
                '-21': 'Orientul Mijlocio', // rumano
                '-22': 'Bliski Wschód', // polaco
                '-26': 'Midden-Oosten', // flamenco
                '-27': 'Střední Východ', // checo
                '-28': 'Stredný Východ', // eslovaco
                '-30': 'Близкия Изток', // búlgaro
                '-33': 'Artimieji Rytai', // Lituano LT
                '-34': 'Lähis-Ida', // Estonio ET
                '-35': 'Tuvie Austrumi', // Letón LV
                '-36': 'Srednji Vzhod', // Esloveno
                '-37': 'ตะวันออกกลาง', // Tailandés
                '-38': 'Srednji Istok', // croata
                '-39': 'Mellem Østen', // danés
                '-40': 'Midtøsten', // noruego
                '-43': 'Middle East', // Turco
                '-44': 'الشرق الأوسط', // Árabe AR
                '-47': 'Близький Схід', // Ukranian
                '-49': 'Timur Tengah', // Indonesio
                '-50': 'Oriente Medio', // mexicano
                '-52': 'המזרח התיכון', // Hebreo
                '-53': 'Bliski Istok', // Serbio
                '-54': 'Trung Đông', // Vietnamita
                '-55': 'Middle East', // Albanés
                '-56': 'Среден Исток', // Macedonio
                '100': 'Midden-Oosten' //Holandés
            }
        };

        var service = {
            getWWTranslate: getWWTranslate,
            getContinents: getContinents
        };

        return service;

        function getContinents(langId) {
            return [
                {
                    id: 'Africa',
                    description: langId ? _this.translationsTexts['AFRICA'][langId] : ItxTranslateSvc.translateCms('legacy.continent.africa'),
                    continent: 1
                },
                {
                    id: 'America',
                    description: langId ? _this.translationsTexts['AMERICA'][langId] : ItxTranslateSvc.translateCms('legacy.continent.america'),
                    continent: 2
                },
                {
                    id: 'AsiaPacific',
                    description: langId ? _this.translationsTexts['ASIA'][langId] : ItxTranslateSvc.translateCms('legacy.continent.asia'),
                    continent: 3
                },
                {
                    id: 'Europe',
                    description: langId ? _this.translationsTexts['EUROPE'][langId] : ItxTranslateSvc.translateCms('legacy.continent.europe'),
                    continent: 4
                },
                {
                    id: 'Oceania',
                    description: langId ? _this.translationsTexts['OCEANIA'][langId] : ItxTranslateSvc.translateCms('legacy.continent.oceania'),
                    continent: 5
                },
                {
                    id: 'Middle',
                    description: langId
                        ? _this.translationsTexts['MIDDLE_EAST'][langId]
                        : ItxTranslateSvc.translateCms('legacy.ItxWorldWideView.continent.MiddleEast'),
                    continent: 7
                }
            ].sort(function (a, b) {
                return a.description.localeCompare(b.description);
            });
        }

        function getWWTranslate(langId) {
            return (_this.text = {
                men: langId ? _this.translationsTexts['MEN'][langId] : ItxTranslateSvc.translateCms('legacy.common.generic.sectionMen'),
                women: langId ? _this.translationsTexts['WOMEN'][langId] : ItxTranslateSvc.translateCms('legacy.common.generic.sectionWomen'),
                bg: langId ? _this.translationsTexts['BG'][langId] : ItxTranslateSvc.translateCms('legacy.common.generic.sectionBg'),
                currentLanguage: langId
                    ? _this.translationsTexts['CURRENT_LANGUAGE'][langId]
                    : ItxTranslateSvc.translateCms('legacy.currentLanguage'),
                chooseContent: langId ? _this.translationsTexts['CHOOSE_CONTENT'][langId] : ItxTranslateSvc.translateCms('legacy.ChooseContent'),
                currentMarket: langId ? _this.translationsTexts['CURRENT_MARKET'][langId] : ItxTranslateSvc.translateCms('legacy.currentMarket'),
                selectLocation: langId ? _this.translationsTexts['SELECT_LOCATION'][langId] : ItxTranslateSvc.translateCms('legacy.selectLocation'),
                selectShippingCountry: langId
                    ? _this.translationsTexts['SELECT_SHIPPING_COUNTRY'][langId]
                    : ItxTranslateSvc.translateCms('legacy.selectShippingCountry'),
                titleNoResults: langId ? _this.translationsTexts['NO_RESULTS'][langId] : ItxTranslateSvc.translateCms('legacy.customMap_empty')
            });
        }
    }
})();
